/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A weighted edge in the employee data flow graph
 */
export type EmployeeDataFlowEdge = {
  /**
   * Total calls represented by this edge
   */
  callCount: number;
  /**
   * Failed or blocked calls represented by this edge
   */
  failureCount: number;
  /**
   * Stable edge ID
   */
  id: string;
  /**
   * Source node ID
   */
  source: string;
  /**
   * Successful calls represented by this edge
   */
  successCount: number;
  /**
   * Target node ID
   */
  target: string;
};

/** @internal */
export const EmployeeDataFlowEdge$inboundSchema: z.ZodMiniType<
  EmployeeDataFlowEdge,
  unknown
> = z.pipe(
  z.object({
    call_count: z.int(),
    failure_count: z.int(),
    id: z.string(),
    source: z.string(),
    success_count: z.int(),
    target: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "call_count": "callCount",
      "failure_count": "failureCount",
      "success_count": "successCount",
    });
  }),
);

export function employeeDataFlowEdgeFromJSON(
  jsonString: string,
): SafeParseResult<EmployeeDataFlowEdge, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EmployeeDataFlowEdge$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EmployeeDataFlowEdge' from JSON`,
  );
}
